import { render, staticRenderFns } from "./ThemeAdd.vue?vue&type=template&id=3828ffeb&"
import script from "./ThemeAdd.vue?vue&type=script&lang=js&"
export * from "./ThemeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports